import { render, staticRenderFns } from "./ReturnOrders.vue?vue&type=template&id=8ed4f3fa&"
import script from "./ReturnOrders.vue?vue&type=script&lang=js&"
export * from "./ReturnOrders.vue?vue&type=script&lang=js&"
import style0 from "./ReturnOrders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports